import { AuthContainer } from '@sleepstation/auth-jwt'
import { ModalService } from '@sleepstation/components'
import {
  ErrorReporterContext,
  LinkContext,
} from '@sleepstation/components-context'
import { ModalContainer } from '@sleepstation/components-hooks'
import { defaultTheme } from '@sleepstation/themes-public-site'
import { shouldForwardProp } from '@sleepstation/utils'
import PropTypes from 'prop-types'
import React from 'react'
import { CookiesProvider } from 'react-cookie'
import { StyleSheetManager, ThemeProvider } from 'styled-components'
import { Provider as UrqlProvider } from 'urql'
import getEnvironment from '../config/getEnvironment'
import { DEFAULT_PAGE_NAV_STATE } from '../const/nav'
import ApiContext from '../context/ApiContext'
import LocalStorageContext from '../context/LocalStorageContext'
import startup from '../init/startup'
import PageNavContainer from '../state/PageNavContainer'

// -----------------------------------------------------------------------------
// Const
// -----------------------------------------------------------------------------

ThemeProvider.displayName = `ThemeProvider`
UrqlProvider.displayName = `UrqlProvider`

// -----------------------------------------------------------------------------
// Component
// -----------------------------------------------------------------------------

const Providers = ({ appElementId, children }) => {
  const ENVIRONMENT = getEnvironment()

  const {
    errorReporter,
    localStorageApi,
    graphQLClient,
    authApi,
    linkContext,
    authContext,
  } = startup(ENVIRONMENT)

  return (
    <StyleSheetManager shouldForwardProp={shouldForwardProp}>
      <ThemeProvider theme={defaultTheme}>
        <ErrorReporterContext.Provider value={errorReporter}>
          <LinkContext.Provider value={linkContext}>
            <ApiContext.Provider value={authApi}>
              <AuthContainer.Provider initialState={authContext}>
                <UrqlProvider value={graphQLClient}>
                  <LocalStorageContext.Provider value={localStorageApi}>
                    <PageNavContainer.Provider
                      initialState={DEFAULT_PAGE_NAV_STATE}
                    >
                      <ModalContainer.Provider>
                        <CookiesProvider>
                          <ModalService appElement={`#${appElementId}`} />
                          {children}
                        </CookiesProvider>
                      </ModalContainer.Provider>
                    </PageNavContainer.Provider>
                  </LocalStorageContext.Provider>
                </UrqlProvider>
              </AuthContainer.Provider>
            </ApiContext.Provider>
          </LinkContext.Provider>
        </ErrorReporterContext.Provider>
      </ThemeProvider>
    </StyleSheetManager>
  )
}

Providers.propTypes = {
  children: PropTypes.node.isRequired,
  appElementId: PropTypes.string.isRequired,
}

export default Providers
